<template>
  <div class="icon-addon addon-lg">
    <select :id="idt" class="wide form-control br-1" :value="value" @change="changeValue">
      <option :data-display="$t(this.displayName)" :value="0">{{ defaultValue }}</option>
      <option v-for="v in values" :value="v.id">{{ $i18n.locale === 'zh' ? v.c_fullname : v.e_fullname }}</option>
    </select>
    <label :class="icon"></label>
  </div>
</template>
<script>
export default {
  name: 'NiceSelect',
  model: {
    prop: 'value',
    event: 'change'
  },
  props: ['values', 'icon', 'displayName', 'defaultValue', 'value', 'idt'],
  methods: {
    changeValue: function(val) {
      console.log(val)
      this.$emit('update:value', val)
    }
  }
}
  
</script>
